import * as containers from './containers'

const routes = [
  {
    path: '/',
    exact: true,
    component: containers.Home
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/features/Home/routes.js